export const OB_ACCEPT_CONTROL_VARIANT = 'A';
export const OB_ACCEPT_OPTED_IN_VARIANT = 'B';
export const OB_ACCEPT_MODAL_VARIANT = 'C';
